module.exports = __webpack_public_path__ + "img/full4-min.0075ac54.png";